import LegalPage from './LegalPage';

export default LegalPage;
